<template>
    <div class="DelegationComponent">

        <b-form autocomplete="off">
            
            <b-form-group v-if="isDelegate" id="input-group-Users" :label="lang.label_Users+':'"
                label-for="input-2">
                <b-form-select v-model="selectedUser" :options="usersList" size="sm" class="mt-3">
                </b-form-select>

            </b-form-group>

            <b-form-group v-if="!isDelegate" id="input-group-Reason" :label="lang.label_Reason+':'"
                label-for="input-2">
                <b-form-textarea id="textarea_reason" size="sm" :placeholder="lang.placeholder_Reason" rows="5"
                    max-rows="10" v-model="reason"></b-form-textarea>

            </b-form-group>



        </b-form>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'


export default {
    name: "DelegationComponent",
    components: {



    },
    props: {
        lang: Object
    },
    data() {
        return {
            
            selectedUser: null,
            usersList: [
                {
                    value: null,
                    text: "Choose a user..."
                }
            ],
            reason: ""
        }
    },
    computed: {
        ...mapGetters({

            currentUser: 'currentUser'

        }),
        isDelegate() {
            return this.lang.label_Users != undefined;
        }
    },
    created() {
        let vue = this;


        this.$store.dispatch('u_getUsersBasic')
            .then((result) => {
                console.log(result.data)


                if (result.status == "OK") {
                    vue.createUsersList(result.data);

                    
                } else {

                }

            })

    },
    updated() {

        const form = {
        
           userId: this.selectedUser,
           reason: this.reason
        }

        
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_delegationForm", form)
        
    },
    methods: {
        createUsersList(data) {

            for (let i = 0, lei = data.length; i < lei; i++){
                if (this.currentUser.userId != data[i].userId) {
                    const obj = {
                        value: data[i].userId,
                        text: data[i].FirstName + " " + data[i].LastName
                    }
                    this.usersList.push(obj);
                }
                
            }
            
        }
    }
}
</script>
<style lang="scss">

    .DelegationComponent {
        
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/DelegationComponent.vue